import { useEffect } from 'react'
import { toast } from 'sonner'
import { authFetch } from '@/lib/auth-fetch'
import { formatAmount, todayString } from '@/lib/utils'


type InsertedItem = {
  recurring_transaction_id: string
  name: string
  amount: number
  target_year_month: string
  transaction_id: string
}

type ProcessResult = {
  inserted: InsertedItem[]
  skipped_existing: number
  capped: boolean
  capped_items: string[]
}

export function RecurringProcessor() {
  useEffect(() => {
    const key = 'recurring-processed'
    const today = todayString()
    const lastProcessed = sessionStorage.getItem(key)

    if (lastProcessed === today) return

    authFetch('/api/recurring/process', { method: 'POST' })
      .then((r) => r.json())
      .then((result: ProcessResult) => {
        sessionStorage.setItem(key, today)
        if (!result.inserted || result.inserted.length === 0) return

        // Group by recurring_transaction name
        const grouped = result.inserted.reduce(
          (acc, item) => {
            if (!acc[item.name]) {
              acc[item.name] = { name: item.name, amount: item.amount, months: [] }
            }
            acc[item.name].months.push(item.target_year_month)
            return acc
          },
          {} as Record<string, { name: string; amount: number; months: string[] }>
        )

        for (const entry of Object.values(grouped)) {
          const formatMonth = (ym: string) => {
            const [y, m] = ym.split('-')
            return `${y}年${parseInt(m)}月`
          }

          if (entry.months.length === 1) {
            toast.info('固定支出を自動登録しました', {
              description: `${entry.name} ${formatAmount(entry.amount)} (${formatMonth(entry.months[0])})`,
            })
          } else {
            const monthList = entry.months.map(formatMonth).join(', ')
            toast.info(`固定支出を自動登録しました (${entry.months.length}件)`, {
              description: `${entry.name} ${formatAmount(entry.amount)} × ${entry.months.length}ヶ月分\n(${monthList})`,
            })
          }
        }

        if (result.capped && result.capped_items.length > 0) {
          for (const name of result.capped_items) {
            toast.warning(
              `「${name}」の自動登録が12ヶ月分を超えています。設定を確認してください。`
            )
          }
        }
      })
      .catch(() => {
        toast.error('固定支出の自動処理に失敗しました')
      })
  }, [])

  return null
}
